export const setAffectationRegClient = (value) => {
  return (dispatch) => {
    dispatch({ type: "AFF_REG_CLI", payload: value });
  };
};
